/**
 * Independent Meta Pixel AddToCart tracking.
 *
 * NOT implemented as a window.fetch wrapper: GoKwik's own externally-hosted
 * merchant-integration.js wraps window.fetch itself for its own analytics
 * (confirmed live — it throws/retries and leaves window.fetch in a state
 * that silently drops a second wrapper layered on top). Fighting over
 * window.fetch with a script we don't control is fragile, so this is a
 * plain shared function instead, called directly from the two places that
 * already have the /cart/add response in hand: product-form.js (native
 * <product-form> element — covers the main Add to Cart button and Dawn's
 * quick-add modal) and custom-atc-drawer.js (the .formAtcForm/.mobile-atc-form
 * quick-add cards, which don't use <product-form>).
 *
 * GoKwik does not claim or intercept the Add to Cart button (confirmed: no
 * data-gokwik-processed / gokwik-marge on button[name="add"]), so these two
 * call sites are the complete set of add-to-cart paths on this theme.
 */
window.dsTrackMetaAddToCart = function (data) {
  if (typeof fbq !== 'function' || !data) return;

  // /cart/add(.js) returns either a single line item object (one variant
  // added) or { items: [...] } (bulk add, e.g. quick order list).
  var items = data.items || (data.id ? [data] : []);
  if (!items.length) return;

  var contentIds = items.map(function (item) {
    return String(item.variant_id || item.id);
  });
  var value = items.reduce(function (sum, item) {
    return sum + (item.price * item.quantity) / 100;
  }, 0);

  var dsAddToCartId = 'atc_' + Date.now() + '_' + Math.random().toString(36).slice(2);
  fbq(
    'track',
    'AddToCart',
    {
      content_ids: contentIds,
      content_type: 'product',
      value: value,
      currency: window.shopCurrency || 'INR',
    },
    { eventID: dsAddToCartId }
  );
};
